export function configurationQueuePath(): string {
  return "/manufacturing/configuration";
}

export function configurationBuildPath(batchItemId: number): string {
  return `/manufacturing/configuration/build/${batchItemId}`;
}

export function configurationAlternateOrderPath(alternateOrderId: number): string {
  return `/manufacturing/configuration/alternate-order/${alternateOrderId}`;
}

export function configurationAlternatePath(sku: string): string {
  const trimmed = sku.trim();
  if (trimmed === "") {
    return "/manufacturing/configuration/alternate";
  }
  return `/manufacturing/configuration/alternate?sku=${encodeURIComponent(trimmed)}`;
}
